import { FileText } from 'lucide-react';
import { urlPvSeance, type SeanceAffichee } from '../../lib/useEmargement';

function horodatage(iso: string): string {
  return new Date(iso).toLocaleString('fr-FR', {
    timeZone: 'Indian/Reunion',
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * PV archivé d'une feuille clôturée, et ses versions antérieures à une
 * réouverture. Le PV nomme toute la demi-journée : il n'est rangé dans aucun
 * dossier, il se lit d'ici, par une route gardée qui trace chaque lecture.
 */
export function LiensPv({ seance }: { seance: Pick<SeanceAffichee, 'id' | 'pvs'> }): JSX.Element | null {
  const [actuel, ...anciens] = seance.pvs;
  if (!actuel) return null;

  return (
    <div className="space-y-1.5">
      <a
        href={urlPvSeance(seance.id)}
        target="_blank"
        rel="noreferrer"
        className="inline-flex min-h-[44px] items-center gap-2 rounded-xl border border-gray-200 bg-white px-4 text-sm font-semibold text-codialis-navy transition hover:bg-gray-50"
      >
        <FileText className="h-4 w-4 shrink-0" aria-hidden="true" />
        Feuille d’émargement (PV)
      </a>
      {anciens.length > 0 && (
        <p className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-codialis-gray">
          <span>Clôtures précédentes :</span>
          {anciens.map((pv) => (
            <a
              key={pv.id}
              href={urlPvSeance(seance.id, pv.id)}
              target="_blank"
              rel="noreferrer"
              className="inline-flex min-h-[32px] items-center font-semibold text-codialis-sky hover:underline [@media(pointer:coarse)]:min-h-[40px]"
            >
              {horodatage(pv.genereLe)}
            </a>
          ))}
        </p>
      )}
    </div>
  );
}
